// @flow
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as Mastercard } from '../../assets/icons/Mastercard_2019_logo 1.svg';
import { ReactComponent as Visa } from '../../assets/icons/visa.svg';
import PricingCard from '../../components/Pricing/Pricing';
import usePricingData from './usePricingData';
import Preloader from '../../components/Preloader';
import { Button } from '../../components';
import Modal from '../../components/ModalProfile';
import { ReactComponent as Jackdaw } from 'assets/svg/jackdaw.svg';
import styles from './styles.module.scss';
import actionTypes from '../../store/payment/actionTypes';

type ModalInfo = {
  title: string,
  id: string,
  to: string,
};

type Props = {
  user: any,
  isYear: boolean,
  cancelHandler: () => void,
  upgradeModalInfo: ModalInfo,
  setUpgradeModalInfo: () => void,
  resumeHandler: () => void,
}

const MODAL_INFO_INIT = {
  title: '',
  id: '',
  to: '',
};

const name = {
  advanced: 'Advanced',
  basic: 'Basic',
  basicannual: 'Basic annual',
  advancedannual: 'Advanced annual',
  plo4: 'PLO4',
  plo5: 'PLO5',
  plo4plo5: 'PLO4+PLO5',
  plo4annual: 'PLO4 annual',
  plo5annual: 'PLO5 annual',
  plo4plo5Annual: 'PLO4+PLO5 annual',
};

const plansInclude = [
  'Training for PLO4 (limited)',
  'Preflop for PLO4',
  'Compare ranges',
  'EV',
  'Discord',
];

const Pricing = ({
  user, isYear, cancelHandler, upgradeModalInfo, setUpgradeModalInfo, resumeHandler,
}: Props) => {
  const isLoadingCancelSub = useSelector((state) => state.api.CANCEL_SUB.loading);
  const isLoadingUpgradeCost = useSelector((state) => state.api.UPGRADE_COST.loading);
  const isLoadingUpgrade = useSelector((state) => state.api.UPGRADE.loading);
  const payment = useSelector((state) => state.payment);
  const [modalInfo, setModalInfo] = React.useState<ModalInfo>(MODAL_INFO_INIT);
  const { pricing } = usePricingData({
    user, isYear, setModalInfo, cancelHandler, resumeHandler,
  });

  const dispatch = useDispatch();

  const previousRate = `${name[payment?.rate]} (€${payment?.price}/${payment?.price > 100 ? 'year' : 'month'})`;

  useEffect(() => {
    setModalInfo(upgradeModalInfo);
    if (upgradeModalInfo.title !== '') {
      dispatch({ type: actionTypes.UPGRADE_COST, payload: upgradeModalInfo.id });
    }
  }, [upgradeModalInfo]);

  useEffect(() => {
    setUpgradeModalInfo();
  }, []);

  return (
    <>

      <div className={styles.carouselWrapper}>
        <div className={styles.tariffNotes}>
          <div className={styles.freeTitle}>FREE</div>
          <div className={styles.freeFeatures}>
            {plansInclude.map((plan, index) => (
              <div
                className={`${styles.tariffNotesItem} ${index === 1 || index === 2 ? styles.tariffNotesMuted : ''}`}
                key={plan}
              >
                <Jackdaw />
                <span>{plan}</span>
              </div>
            ))}
          </div>
          <div className={styles.freeButtonWrapper}>
            <div className={styles.freeButton}>
              Try Free
            </div>
          </div>
        </div>
        {pricing?.map((card) => (
          <div
            className={styles.carouselItemWrapper}
            key={card.id}
          >
            <PricingCard
              type={card.type}
              isYear={card.isYear}
              total={card.total}
              button={card.button}
              title={card.title}
              text={card.text}
              price={card.price}
              backGround={card.backGround}
              features={card.features}
              oldPrice={card.oldPrice}
              subtext={card.subtext}
              backGroundImage={card.backGroundImage}
              borderTopColor={card.borderTopColor}
              isCombination={card.isCombination}
              percentage={card.percentage}
              percentageColor={card.percentageColor}
            />
          </div>
        ))}
      </div>

      <Modal
        className={styles.modal}
        classNameCross={styles.modalCross}
        classNameCrossWrapper={styles.modalCross}
        classNameModalContent={styles.modalContent}
        isOpen={!!modalInfo.title}
        onClose={() => {
          setModalInfo(MODAL_INFO_INIT);
          setUpgradeModalInfo();
        }}
      >
        <Preloader isLoading={isLoadingCancelSub || isLoadingUpgradeCost}>
          <div className={styles.infoTariffWrapper}>
            <div className={styles.titleModal}>
              {modalInfo.title}
            </div>

            <div className={styles.infoTariff}>
              <div className={styles.type}>From</div>
              <div className={styles.nameTariff}>{previousRate}</div>
            </div>
            <div className={styles.infoTariff}>
              <div className={styles.type}>To</div>
              <div className={styles.nameTariff}>{modalInfo?.to}</div>
            </div>
          </div>

          <div>
            <div className={styles.paymentTotal}>
              <div className={styles.total}>Total</div>
              {`€${payment?.total}`}
            </div>

            <div className={styles.pay}>
              {
                payment?.type === 'visa' ? <Visa /> : <Mastercard />
              }
              <div className={styles.payInfo}>
                <div className={styles.payInfoTitle}>Pay using</div>
                <div className={styles.payInfoNumberWrapper}>
                  Card ending in
                  <div className={styles.payInfoNumber}>{payment?.card}</div>
                </div>
              </div>
            </div>

            <div className={styles.buttonWrapper}>
              <Button
                loading={isLoadingUpgrade}
                className={styles.buttonUpdate}
                name="PROCESS TO CHECKOUT"
                onClick={() => dispatch({ type: actionTypes.UPGRADE, payload: modalInfo.id })}
              />
            </div>
          </div>
        </Preloader>
      </Modal>

    </>
  );
};

export default Pricing;
